import { PropsWithChildren } from 'react'
import {
  MarketButton,
  MarketContentCard,
  MarketRow,
} from '@market/react/components'

type Props = {
  isRedeemed?: boolean
  kind: 'available-offer' | 'unavailable-offer' | 'redeemed-offer'
  offerId: string
}

const OfferCard = ({
  children,
  kind,
  offerId,
  isRedeemed = false,
}: PropsWithChildren<Props>) => {
  return (
    <MarketContentCard
      className={`addons-rewards-content-card ${
        isRedeemed
          ? 'addons-rewards-content-card-redeemed'
          : 'addons-rewards-content-card-unredeemed'
      }`}
    >
      <MarketRow data-testid={`${kind}-${offerId}-card`}>{children}</MarketRow>
    </MarketContentCard>
  )
}

const Label = ({ children }: PropsWithChildren<{}>) => {
  return (
    <label slot="label" className="addons-market-action-card-label">
      {children}
    </label>
  )
}

const Subtext = ({ children }: PropsWithChildren<{}>) => {
  return (
    <div slot="subtext" className="addons-market-action-card-subtext">
      {children}
    </div>
  )
}

const ErrorText = ({ children }: PropsWithChildren<{}>) => {
  return (
    <div slot="subtext" className="addons-market-action-card-error-text">
      {children}
    </div>
  )
}

type ButtonProps = {
  isLoading?: boolean
  isDisabled?: boolean
  onClick?: VoidFunction
}

const Button = ({
  onClick,
  children,
  isLoading = false,
  isDisabled = false,
}: PropsWithChildren<ButtonProps>) => {
  // If we set disabled={false} on the button, it still acts as disabled
  // so we avoid setting the prop at all unless we want to set it to true
  const btnDisabledProp = (() => {
    if (isDisabled) {
      return {
        disabled: true,
      }
    }

    return {}
  })()

  return (
    <MarketButton
      slot="control"
      rank="secondary"
      isLoading={isLoading || undefined}
      onClick={onClick}
      {...btnDisabledProp}
    >
      {children}
    </MarketButton>
  )
}

export default OfferCard

OfferCard.Label = Label
OfferCard.Subtext = Subtext
OfferCard.ErrorText = ErrorText
OfferCard.Button = Button
